export const getOpportunityEditionInfo = (updatedOpportunity, originalOpportunity) => {
  const currentRestOpportunity = updatedOpportunity.itineraries.map(itinerary => ({...itinerary, days: []}))
  const originalRestOpportunity = originalOpportunity.itineraries.map(itinerary => ({...itinerary, days: []}))

  const currentOpportunityDays = updatedOpportunity.itineraries.flatMap(itinerary => itinerary.days)
  const originalOpportunityDays = originalOpportunity.itineraries.flatMap(itinerary => itinerary.days)

  const currentOpportunityWithOutDays = formatSpecialCharactersFromObject({...updatedOpportunity, itineraries: currentRestOpportunity})
  const originalOpportunityWithOutDays = formatSpecialCharactersFromObject({...originalOpportunity, itineraries: originalRestOpportunity})
  const isModifiedDays = JSON.stringify(currentOpportunityDays) !== JSON.stringify(originalOpportunityDays)
  const isModifiedRestOpportunity = currentOpportunityWithOutDays !== originalOpportunityWithOutDays
  return { isModifiedDays, isModifiedRestOpportunity }
}

export const formatSpecialCharactersFromObject = (object) => {
  return JSON.stringify(object).replaceAll("&lt;", "<").replaceAll("&gt;", ">").replaceAll("&nbsp;", " ").replaceAll("&amp;", "&").replaceAll("figure", "div")
}